import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './index.styl'

const MajorNews = ({ pageData, activeCat }) => {
  const { t } =  useTranslation()
  return (
    <div className="major-news investor__main">
      <h2 className="investor__title">{t(`nav_${activeCat}`)}</h2>
      <a href={pageData[0].link} target="_blank">{pageData[0].title}</a>
      <div
        className="major-news__instructions"
        dangerouslySetInnerHTML={{ __html: pageData[0].instructions.split(/[\n\r|\n|\r\n]/).join('<br>')}}
      />
    </div>
  )
}

MajorNews.propTypes = {}

export default MajorNews
